export default {
  addPetSuccess: 'Your pet has been succesfully added!',
  addPetFailure: 'Ruff luck. We couldn\'t add your pet.',
  addImageSuccess: 'What a purrfect picture!',
  addImageFailure: 'Ruff luck. We couldn\'t upload your image',
  addCareSuccess: 'Success!',
  addCareFailure: 'Ruff luck. We couldn\'t upload your care detail.',
  updatePetSuccess: 'This furever friend has been updated',
  updatePetFailure: 'Ruff luck. We couldn\'t update your pet\'s details.'
}



// WEBPACK FOOTER //
// ./src/portal/messages.js